import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  contacts: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const ContactSlice = createSlice({
  name: "contacts",
  initialState: INITIAL_STATE,
  reducers: {
    fetchContactData: (state) => {
      state.contacts.isLoading = true;
    },
    fetchContactSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      contacts: {
        ...state.contacts,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchContactFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      contacts: {
        ...state.contacts,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearContacts: (state) => ({
      ...state,
      contacts: {
        ...state.contacts,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: null,
      },
    }),
  },
});

export const {
  fetchContactData,
  fetchContactFailure,
  fetchContactSuccess,
  clearContacts,
} = ContactSlice.actions;
export const ContactReducer = ContactSlice.reducer;
